/** Tenant permission keys — keep in sync with backend PermissionCatalog. */
export const PERMISSIONS = {
  VIEW_DASHBOARD: 'view_dashboard',
  DASHBOARD_WIDGET_METRICS: 'dashboard_widget_metrics',
  DASHBOARD_WIDGET_CHARTS: 'dashboard_widget_charts',
  DASHBOARD_WIDGET_SALES_UPTIME: 'dashboard_widget_sales_uptime',
  DASHBOARD_WIDGET_INVENTORY: 'dashboard_widget_inventory',
  DASHBOARD_WIDGET_ACTIVITIES: 'dashboard_widget_activities',
  DASHBOARD_WIDGET_RECENT_SALES: 'dashboard_widget_recent_sales',
  DASHBOARD_WIDGET_RECENT_SELL_ADJUSTMENTS: 'dashboard_widget_recent_sell_adjustments',
  DASHBOARD_WIDGET_RECENT_STOCK: 'dashboard_widget_recent_stock',
  DASHBOARD_WIDGET_RECENT_LEDGERS: 'dashboard_widget_recent_ledgers',

  VIEW_STAFF: 'view_staff',
  CREATE_STAFF: 'create_staff',
  EDIT_STAFF: 'edit_staff',
  DELETE_STAFF: 'delete_staff',
  ASSIGN_SHOP: 'assign_shop',
  RESET_PASSWORD: 'reset_password',
  MANAGE_ROLES: 'manage_roles',
  VIEW_PERMISSIONS: 'view_permissions',
  ASSIGN_PERMISSIONS: 'assign_permissions',

  VIEW_SHOPS: 'view_shops',
  MANAGE_SHOPS: 'manage_shops',
  EDIT_SHOP_SETTINGS: 'edit_shop_settings',

  VIEW_SHOP_ITEMS: 'view_shop_items',
  CREATE_SHOP_ITEMS: 'create_shop_items',
  EDIT_SHOP_ITEMS: 'edit_shop_items',
  DELETE_SHOP_ITEMS: 'delete_shop_items',

  VIEW_INVENTORY: 'view_inventory',
  CREATE_INVENTORY: 'create_inventory',
  EDIT_INVENTORY: 'edit_inventory',
  DELETE_INVENTORY: 'delete_inventory',

  VIEW_PURCHASE: 'view_purchase',
  CREATE_PURCHASE: 'create_purchase',
  EDIT_PURCHASE: 'edit_purchase',

  VIEW_SALES: 'view_sales',
  CREATE_SALES: 'create_sales',
  EDIT_SALES: 'edit_sales',

  VIEW_PURCHASE_ADJUSTMENTS: 'view_purchase_adjustments',
  MANAGE_PURCHASE_ADJUSTMENTS: 'manage_purchase_adjustments',
  VIEW_SALES_ADJUSTMENTS: 'view_sales_adjustments',
  MANAGE_SALES_ADJUSTMENTS: 'manage_sales_adjustments',

  VIEW_STOCK_MOVEMENTS: 'view_stock_movements',
  VIEW_LEDGER: 'view_ledger',

  VIEW_MANUFACTURERS: 'view_manufacturers',
  MANAGE_MANUFACTURERS: 'manage_manufacturers',

  VIEW_UNITS: 'view_units',
  MANAGE_UNITS: 'manage_units',

  VIEW_SETTINGS: 'view_settings',
  EDIT_SETTINGS: 'edit_settings',
} as const;

export type PermissionKey = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
